import { Log } from 'ng2-logger';
import {
    IAddModalSaveUsersGetAction,
    IProjectFetchAllGroupsGetAction,
    IProjectFetchUsersOfGroupGetAction
} from '../../src/models/action/project';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { IFilterStudent } from '../models/components/add-activity-project-content';
import ApiClient from './alms-api';
const token: any = localStorage.getItem('access_token');
const _logger = Log.create('Project-Service');
const T = Translator.create();
let _apiClient: ApiClient;

export class ProjectService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestAddProjectActivityAsync(params: any) {
        return _apiClient
            .RequestAsync(params.ProjectData.activityId ? 'PUT' : 'POST', 'api/project', params.ProjectData)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestGetProjectAsync(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/activitylist', params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }

    public async RequestGetUpdateProjectActivity(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/project/get', params)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return false;
            });
    }

    public async AddGroup(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/group', params)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                Notification.setNotification('success', T.t('r_project_activity_group_create_success_message'), 'topRight');
                return result;
            })
            .catch(response => {
                return false;
            });
    }
    public async AutoAddGroup(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/group/createauto', params)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async updateGroup(params: any) {
        return _apiClient
            .RequestAsync('PUT', 'api/group', params)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData;
                }
            })
            .then((result: any) => {
                Notification.setNotification('success', T.t('r_project_activity_group_update_success_message'), 'topRight');
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_project_activity_group_update_error_message'), 'topRight');
                return false;
            });
    }

    public async FetchAllGroups(params: IProjectFetchAllGroupsGetAction) {
        return _apiClient
            .RequestAsync('POST', 'api/organization/search', params)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return false;
            });
    }

    public async AddUsersToGroup(params: IAddModalSaveUsersGetAction) {
        return _apiClient
            .RequestAsync('POST', 'api/group/' + params.groupId + '/user', params.addList)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return false;
            });
    }

    public async FetchUsersOfGroup(params: IProjectFetchUsersOfGroupGetAction) {
        return _apiClient
            .RequestAsync('GET', 'api/group/' + params.groupId + '/users' + '?take=' + params.take + '&skip=' + params.skip)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    responseData
                        .text()
                        .then(data => {
                            Notification.setNotification('error', T.t(data), 'topRight');
                        })
                        .catch();
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return false;
            });
    }

    // Get Lesson-Page Header Information
    public async RequestDeleteProjectActivityAsync(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/project/delete', params.ProjectData, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_project_activity_group_delete_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestDeleteProjectGroup(params: any) {
        return _apiClient
            .RequestAsync('DELETE', 'api/group', params.groupIds, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    return null;
                } else {
                    return responseData;
                }
            })
            .then((result: any) => {
                Notification.setNotification('success', T.t('r_project_activity_group_delete_success_message'), 'topRight');
                return result;
            })
            .catch(response => {
                Notification.setNotification('error', T.t('r_project_activity_group_delete_error_message'), 'topRight');
                return false;
            });
    }

    async RequestGetUsersAddModal(params: IFilterStudent) {
        const skip = (params.page - 1) * 10;
        return _apiClient
            .RequestAsync(
                'GET',
                'api/user/search?' +
                    'classId=' +
                    params.classId +
                    '&courseId=' +
                    params.courseId +
                    '&skip=' +
                    skip +
                    '&take=' +
                    params.take +
                    '&searchKey=' +
                    params.searchKey +
                    '&userType=' +
                    params.userType +
                    '&disallowedGroupIds=' +
                    params.disallowedGroupIds +
                    '&selectedGroupId=' +
                    params.selectedGroupId,
                null,
                token
            )
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_assignment_grade_student_list_error_message'), 'topRight');
                return false;
            });
    }
}
